import { call, put } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import apiMiddleware from 'services/api_middleware'
import app_config from 'config/app_config'

import { onOpenNotification } from 'redux/notification/reducer'

import {
	archiveInvoicesRequestSuccess,
	invoiceRequestComplete,
} from '../reducer'

export function* archiveInvoicesSaga({
	payload,
}: PayloadAction<{ invoiceIds: string[], archive: boolean }>) {
	try {
		const { message }: { message: string } = yield call(apiMiddleware, {
			url: app_config.services.archiveInvoice,
			method: 'POST',
			data: payload,
		})

		yield put(
			onOpenNotification({
				message,
				notificationType: 'success',
			})
		)

		yield put(archiveInvoicesRequestSuccess())
	} catch (e) {
		yield put(invoiceRequestComplete())

		const error = e as { message: string }

		yield put(
			onOpenNotification({
				message: error.message,
				notificationType: 'error',
			})
		)
	}
}
